import Head from 'next/head';
import React from 'react';

const title = 'Wedding Photo Albums - Free Shipping!';
const description =
  'Capture the magic of your wedding day forever with our personalized wedding albums, expertly designed to showcase every precious moment in stunning detail.';

const Header: React.FC = (): JSX.Element => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/zola-heart-marine.png"
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="zola.com" />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <link rel="canonical" href="https://www.zola.com/wedding-albums/shop" />
    </Head>
  );
};

export default Header;
